import React from 'react';
import styles from './styles';
import { useEffect } from 'react';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import SignalWifiOffIcon from '@material-ui/icons/SignalWifiOff';
import RouterIcon from '@material-ui/icons/Router';
import Snackbar from '@material-ui/core/Snackbar';
import PropTypes from 'prop-types';
import useStyles from "./styles";
import ClickAwayListener from '@material-ui/core/ClickAwayListener'

function WaitingToast() {
  const [open, setOpen] = React.useState(true);
  const classes = useStyles();
  const handleClose = reason => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };


  return (
    <div>
      <Snackbar
        className={classes.anchorOriginTopCenter}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        ContentProps={{
          classes: {
            root: classes.root,
            action: classes.action
          }
        }}
        open={open}
        message={
          <div className={classes.snackBarContent}>
            Waiting for other party to join...
          </div>
        }
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={handleClose}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
      />
    </div>
  );
}

export default WaitingToast;